export default __webpack_public_path__ + "eb2de7f4e3ac8f8c765370f223e09f9b.svg";